import { SAVED_SEARCH_ACTION_KEYS } from 'features/saved-searches/constants';

const getTotalWidth = ({ controlWidths, gapWidth }) => {
  if (!controlWidths.length) return 0;

  return (
    controlWidths.reduce((total, width) => total + width, 0) + gapWidth * (controlWidths.length - 1)
  );
};

export const getToolbarActionDistribution = ({
  actionKeys = [],
  actionWidths = {},
  availableWidth = 0,
  fixedWidth = 0,
  gapWidth = 0,
  overflowTriggerWidth = 0
}) => {
  const availableActionKeys = actionKeys.filter(key => actionWidths[key] != null);

  const fits = inlineActionKeys => {
    const overflowActionCount = availableActionKeys.length - inlineActionKeys.length;
    const controlWidths = [fixedWidth, ...inlineActionKeys.map(key => actionWidths[key])].filter(
      width => width > 0
    );

    if (overflowActionCount) controlWidths.push(overflowTriggerWidth);

    return getTotalWidth({ controlWidths, gapWidth }) <= availableWidth;
  };

  let inlineActionKeys = availableActionKeys;

  while (inlineActionKeys.length && !fits(inlineActionKeys)) {
    inlineActionKeys = inlineActionKeys.slice(0, -1);
  }

  return {
    inlineActionKeys,
    overflowActionKeys: availableActionKeys.filter(key => !inlineActionKeys.includes(key))
  };
};

/**
 * Normalizes the raw saved-search props into a priority-ordered list of toolbar actions.
 * Order encodes visibility priority (highest first); the lowest-priority action collapses first.
 * Definitions are matched by their explicit `key`; a definition without a key is ignored.
 */
export const buildToolbarActions = ({
  savedSearchButtonDefinitions = [],
  activeSearch,
  savedSearchAppliedProps,
  copies
}) => {
  const propsByKey = savedSearchButtonDefinitions.reduce((acc, { key, props }) => {
    if (key) acc[key] = props;
    return acc;
  }, {});

  const saveOrEdit =
    activeSearch && savedSearchAppliedProps?.onSaveSearch
      ? {
          key: SAVED_SEARCH_ACTION_KEYS.saveOrEdit,
          text: savedSearchAppliedProps.isDirty ? copies.saveSearch : copies.editSearch,
          variant: 'text',
          onClick: savedSearchAppliedProps.onSaveSearch
        }
      : null;

  const fromDefinition = key => (propsByKey[key] ? { key, ...propsByKey[key] } : null);

  return [
    saveOrEdit,
    fromDefinition(SAVED_SEARCH_ACTION_KEYS.savedSearches),
    fromDefinition(SAVED_SEARCH_ACTION_KEYS.saveAsNew)
  ].filter(action => typeof action?.onClick === 'function');
};
